import passwordStrength from '../modules/password-strength';

const initialize = () => {
    const $button = $('button[type="submit"]');

    passwordStrength($button);

    $button.on('keypress click', (e) => {
        if ($button.is(':disabled') || $button.hasClass('disabled') || !$('#password').data('is-password-strong')) {
            $('form').validator('validate');
            e.preventDefault();

            return;
        }
    });
};

export default initialize;
